<template lang="pug">
#tabela-processos-judiciais-pj
    div(v-if='items && items.length > 0')
        el-table(
            :data='items',
            style='width: 100%; height: 100%;',
            stripe,
            v-loading='loadingPage'
        )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.processosJudiciais.numeroDoProcessoNome')",
                :formatter='formatProcess',
                align='left',
                min-width='140px'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.processosJudiciais.numeroDoProcessoCnj')",
                prop='processo',
                :formatter='formatProcessNumber',
                min-width='120px',
                align='left'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.processosJudiciais.acoes')",
                align='center',
                min-width='50'
            )
                .template.d-flex.justify-content-center(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='abrirModalDetalhesProcesso(scope.row)'
                            ) {{ $t('mensagens.preAnaliseCredito.verInformacoesDetalhadas') }}
        .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
            .tabela-rodape-somatorio(v-if='items.length > 0')
                p {{ dados.total }} {{ $t('mensagens.preAnaliseCredito.processosJudiciais.processosMinusculo') }}
            el-pagination(
                v-if='items.length > 0',
                :page-size='10',
                :pager-count='10',
                layout='prev, pager, next',
                :total='totalPages',
                :current-page='paginaAtual',
                @prev-click='voltarPagina',
                @next-click='avancarPagina',
                @current-change='atualizarPagina'
            )
    BaseModalVisualizarInfos(
        v-if='modalDetalhesProcessos'
        :show='modalDetalhesProcessos',
        width='800px',
        @closeDialog='modalDetalhesProcessos = false; dadosModalDetalhesProcessos = ""'
    )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.informacoesGerais')", name='0')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.informacoesGerais') }}
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.classe'), $t('mensagens.preAnaliseCredito.processosJudiciais.vara')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.classe, dadosModalDetalhesProcessos.orgaoJulgador]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.segmentoDaJustica'), $t('mensagens.preAnaliseCredito.processosJudiciais.juizRelator')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.segmento, dadosModalDetalhesProcessos.juiz ? dadosModalDetalhesProcessos.juiz.nome : dadosModalDetalhesProcessos.juiz]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.ramoDoDireito'), $t('mensagens.preAnaliseCredito.processosJudiciais.tribunalResponsavelPeloProcesso')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.ramoDireito, dadosModalDetalhesProcessos.tribunal]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.unidadeDeOrigemDoProcesso'), $t('mensagens.preAnaliseCredito.processosJudiciais.ufDoProcesso')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.unidadeOrigem, dadosModalDetalhesProcessos.uf]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="titulosInfoBlockMonetario"
                    :valores-info-block="valoresInfoBlockMonetario"
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.statusNeoway'), $t('mensagens.preAnaliseCredito.processosJudiciais.statusComplementar')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.statusObservacao, dadosModalDetalhesProcessos.statusComplementar]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.dataDoStatus')]",
                    :valores-info-block='[formatData(dadosModalDetalhesProcessos.dataStatus)]'
                )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.informacoesComplementares')", name='1')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.informacoesComplementares') }}
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.dataDaDistribuicao'), $t('mensagens.preAnaliseCredito.processosJudiciais.grauDoProcesso')]",
                    :valores-info-block='[formatData(dadosModalDetalhesProcessos.dataDistribuicao), dadosModalDetalhesProcessos.grauProcesso]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.localFisico'), $t('mensagens.preAnaliseCredito.processosJudiciais.processoDigital')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.localFisico, formatBooleanField(dadosModalDetalhesProcessos.processoDigital)]'
                )
                el-divider
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.segredoDeJustica')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.ramoDireito]'
                )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.assuntos')", name='2')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.assuntos') }}
                BaseInfoBlock(
                    v-if='dadosModalDetalhesProcessos.assuntos',
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.descricao')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.assuntos.descricao]'
                )
                BaseInfoBlock(
                    :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.categoriaCriminal')]",
                    :valores-info-block='[dadosModalDetalhesProcessos.categoriaCriminal]'
                )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.partesAtivas')", name='3')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.partesAtivas') }}
                el-table(
                    :data='dadosModalDetalhesProcessos.ativos',
                    style='width: 100%; height: 100%; overflow: auto',
                    stripe,
                    v-loading='isLoading'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-table.sub-tabela(
                                :data='props.row.advogados',
                                style='width: 100%; height: 100%; overflow: auto',
                                stripe
                            )
                                el-table-column(
                                    prop='nome',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.advogado')",
                                    min-width='90px'
                                )
                                el-table-column(
                                    prop='cpf',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                                    :formatter='numeralStringFormatTocpfCnpj',
                                    min-width='80px'
                                )
                                el-table-column(
                                    prop='oab',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.registroDaOab')",
                                    min-width='90px'
                                )
                            el-divider
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.categoriaTipo')",
                        prop='tipo',
                        :formatter='isEmpty',
                        align='left',
                        min-width='90px'
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.nome')",
                        prop='nome',
                        align='left'
                        min-width='120px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                        prop='cpf',
                        :formatter='numeralStringFormatTocpfCnpj',
                        align='left'
                        min-width='100px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cnpj')",
                        prop='cnpj',
                        :formatter='numeralStringFormatTocpfCnpj',
                        min-width='100px',
                        align='left'
                    )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.partesPassivas')", name='4')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.partesPassivas') }}
                el-table(
                    :data='dadosModalDetalhesProcessos.passivos',
                    style='width: 100%; height: 100%; overflow: auto',
                    stripe,
                    v-loading='isLoading'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-table.sub-tabela(
                                :data='props.row.advogados',
                                style='width: 100%; height: 100%; overflow: auto',
                                stripe
                            )
                                el-table-column(
                                    prop='nome',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.advogado')",
                                    min-width='90px'
                                )
                                el-table-column(
                                    prop='cpf',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                                    min-width='80px'
                                )
                                el-table-column(
                                    prop='oab',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.registroDaOab')",
                                    min-width='90px'
                                )
                            el-divider
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.categoriaTipo')",
                        prop='tipo',
                        :formatter='isEmpty',
                        sortable,
                        align='left',
                        min-width='90px'
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.nome')",
                        prop='nome',
                        align='left'
                        min-width='120px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                        prop='cpf',
                        :formatter='numeralStringFormatTocpfCnpj',
                        align='left'
                        min-width='100px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cnpj')",
                        prop='cnpj',
                        :formatter='numeralStringFormatTocpfCnpj',
                        min-width='100px',
                        align='left'
                    )
        el-collapse(v-model='activeCollapseItem')
            el-collapse-item(:title="$t('mensagens.preAnaliseCredito.processosJudiciais.outrasPartes')", name='5')
                template(slot='title')
                    | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.outrasPartes') }}
                el-table(
                    :data='dadosModalDetalhesProcessos.outrasPartes',
                    style='width: 100%; height: 100%; overflow: auto',
                    stripe,
                    v-loading='isLoading'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-table.sub-tabela(
                                :data='props.row.advogados',
                                style='width: 100%; height: 100%; overflow: auto',
                                stripe
                            )
                                el-table-column(
                                    prop='nome',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.advogado')",
                                    min-width='90px'
                                )
                                el-table-column(
                                    prop='cpf',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                                    :formatter='numeralStringFormatTocpfCnpj',
                                    min-width='80px'
                                )
                                el-table-column(
                                    prop='oab',
                                    :label="$t('mensagens.preAnaliseCredito.processosJudiciais.registroDaOab')",
                                    min-width='90px'
                                )
                            el-divider
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.categoriaTipo')",
                        prop='tipo',
                        :formatter='isEmpty',
                        sortable,
                        align='left',
                        min-width='90px'
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.nome')",
                        prop='nome',
                        align='left'
                        min-width='120px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cpf')",
                        prop='cpf',
                        :formatter='numeralStringFormatTocpfCnpj',
                        align='left'
                        min-width='100px',
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.processosJudiciais.cnpj')",
                        prop='cnpj',
                        :formatter='numeralStringFormatTocpfCnpj',
                        min-width='100px',
                        align='left'
                    )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/components/preAnaliseCredito/BaseTableHeader';
import BaseInfoBlock from '@/components/preAnaliseCredito/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/components/preAnaliseCredito/BaseModalVisualizarInfos';

export default {
    name: 'TabelaProcessosJudiciaisPj',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        dados: {
            type: Object,
            required: true,
            default: () => ({})
        },
        onPageChange: {
            type: Function,
            required: true
        },
        loadingPage: {
            type: Boolean,
            required: true
        },
        paginaAtual: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            itemsPorPagina: 10,
            isLoading: false,
            modalDetalhesProcessos: false,
            dadosModalDetalhesProcessos: '',
            activeCollapseItem: ['']
        };
    },

    computed: {
        items() {
            return this.dados.results;
        },
        titulosInfoBlockMonetario() {
            return [this.$t('mensagens.preAnaliseCredito.processosJudiciais.moedaValorDaCausa'), this.$t('mensagens.preAnaliseCredito.processosJudiciais.valorMonetarioDaCausa')];
        },
        valoresInfoBlockMonetario() {
            return [
                this.safeAccess(this.dadosModalDetalhesProcessos, 'valorCausa', 'moeda'),
                this.formatValor(this.safeAccess(this.dadosModalDetalhesProcessos, 'valorCausa', 'valor'))
            ];
        }
    },

    methods: {
        safeAccess(obj, ...args) {
            return args.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), obj);
        },
        numeralStringFormatTocpfCnpj(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatBooleanField(value) {
            return value ? 'Sim' : 'Não';
        },
        voltarPagina() {
            if (this.paginaAtual > 1) {
                this.atualizarPagina(this.paginaAtual - 1);
            }
        },
        avancarPagina() {
            if (this.paginaAtual < this.totalPages) {
                this.atualizarPagina(this.paginaAtual + 1);
            }
        },
        atualizarPagina(pagina) {
            if (pagina >= 1 && pagina <= this.totalPages) {
                this.onPageChange(pagina);
            }
        },
        abrirModalDetalhesProcesso(row) {
            this.modalDetalhesProcessos = true;
            this.dadosModalDetalhesProcessos = row;
        },
        formatProcess(row) {
            let processoAntigo = this.formatProcessNumber(
                row.numeroProcessoAntigo
            );
            let nome = row.classe;

            return [processoAntigo, nome].filter(Boolean).join(' / ');
        },
        formatNumber(row, column, number, index) {
            return formatters.formatNumber(number, 2);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        formatProcessNumber(row, column, data, index) {
            if (!data || data.length !== 20) {
                return '...';
            }
            const processString =
                typeof processNumber === 'string' ? data : String(data);

            const digitsOnly = processString.replace(/\D/g, '');

            const formatted = [
                digitsOnly.slice(0, 7),
                digitsOnly.slice(7, 9),
                digitsOnly.slice(9, 13),
                digitsOnly.slice(13, 14),
                digitsOnly.slice(14, 16),
                digitsOnly.slice(16)
            ].join('.');

            return formatted;
        },
        formatarDataTableColumn(row, column, data, index) {
            return this.mxFormatarData(data);
        },
        formatData(valor) {
            return formatters.converterDataFullParaDataBR(valor);
        },
        formatarTexto(texto) {
            if (!texto) {
                return '- -';
            } else {
                return texto.join(', ');
            }
        },
        formatarTextoJuros(texto) {
            let arrayTextos = [];
            texto.forEach(el => {
                arrayTextos.push(Number(el).toFixed(2));
            });
            return arrayTextos.join(', ');
        },
        formatValor(valor) {
            if (!valor) {
                return '- -';
            }

            return formatters.formatNumber(valor, 2);
        }
    }
};
</script>

<style lang="scss">
#tabela-processos-judiciais-pj {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-table {
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        height: 100%;

        .sub-tabela {
            margin-left: 55px;
            max-height: 150px;
            max-width: 87%;
            overflow: auto;
            border: none;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding: 17px 0 15px 21px;
    }

    .el-pagination {
        padding: 16px 75px 16px 0;
        color: #3b3b3b;
    }

    .el-pager li.active {
        color: #00413c;
        font-weight: 600;
        font-size: 15px;
        background: #00413c24;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }
}
</style>
